import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { ImageAssignmentPolicy } from '../../../../projectDetails.models';
import { IProjectActivity, IProjectActivityImageAssignmentPolicyChange } from '../../projectDetailsActivities.models';

export const ChangeImageAssignmentPolicyActivity = ({ values }: IProjectActivity<IProjectActivityImageAssignmentPolicyChange>): ReactElement => {
  const { t } = useTranslator();

  const translateImageAssignmentPolicy = (policy: ImageAssignmentPolicy): string => {
    switch (policy) {
      case ImageAssignmentPolicy.RANDOM:
        return t('image_assignment_policy_random');
      case ImageAssignmentPolicy.SEQUENTIAL:
        return t('image_assignment_policy_sequential');
      case ImageAssignmentPolicy.PARALLEL:
        return t('image_assignment_policy_parallel');
      default:
        return '';
    }
  };

  return (
    <div>
      {t('activity_description_ImageAssignmentPolicyChange')}
      <b> {`${translateImageAssignmentPolicy(values.policy)}.`} </b>
    </div>
  );
};
